<template>

  <van-swipe-cell style="background-color: white;">

    <van-row class="cellContainer">
      <van-col span="2" class="cellLeft">
        <van-checkbox v-model="cellItem.checked" @change="selectChange" checked-color="#07c160"></van-checkbox>
      </van-col>
      <van-col span="6">
        <van-image fit="cover" :src="cellItem.picUrl" />
      </van-col>
      <van-col span="16" class="cellRight">
        <van-row class="cellName">
          <span>{{cellItem.goodsName}}</span>
        </van-row>
        <van-row class="cellDes">
          <div class="cell-des" v-for="(item,idx) in cellItem.specifications" :key="idx">
            <span v-if="idx != cellItem.specifications.length -1 ">{{item}}/</span>
            <span v-else>{{item}}</span>
          </div>

        </van-row>
        <van-row class="cellPrice">

          <van-col span="12"> ￥{{cellItem.price}}</van-col>
          <van-col span="11" style="text-align: right;">
            <van-stepper v-model="cellItem.number" step="1" @change="onChange" />
          </van-col>

        </van-row>
      </van-col>
    </van-row>

    <template #right>
      <van-button square text="删除" type="danger" class="delete-button" @click="cellDelete" />
    </template>
  </van-swipe-cell>

</template>

<script>
import { Image, Dialog } from "vant";
import { cartChecked, cartUpdate, cartDelete } from "@/api/index";
export default {
  name: "shopcardcell",
  comments: [Image],
  props: {
    cellItem: {
      type: Object
    }
  },
  data() {
    return {
      goodNumber: 1,
      checked: true,
      isCheckedData: {
        productIds: [], //productid.销售id ,全选时传多个销售id,逗号隔开
        isChecked: 0 //是否选中.0:取消 1.选中
      },
      numberData: {
        goodsId: this.cellItem.goodsId, //商品id
        id: this.cellItem.id, //购物车商品id
        number: this.cellItem.number, //商品变更后数量
        productId: this.cellItem.productId //销售id
      }
    };
  },
  created() {},
  methods: {
    cellDelete() {
      setTimeout(() => {
        Dialog.confirm({
          title: "提示",
          message: "确定删除该商品？"
        })
          .then(() => {
            // on confirm
            let data = {
              productIds: [this.cellItem.productId]
            };
            cartDelete(data).then(res => {
              console.log(res);
              if (res.data.errno == 0) {
                this.$emit("getStep", "deleted");
              }
            });
          })
          .catch(() => {
            // on cancel
          });
      }, 500);
    },
    selectChange() {
      this.isCheckedData.productIds.push(this.cellItem.productId);

      this.cellItem.checked
        ? (this.isCheckedData.isChecked = 1)
        : (this.isCheckedData.isChecked = 0);
      cartChecked(this.isCheckedData).then(() => {});
      this.$emit("getStep");
    },
    onChange() {
      this.numberData.number = this.cellItem.number;
      cartUpdate(this.numberData).then(res => {
        console.log(res);
      });
      this.$emit("getStep");
    }
  }
};
</script>

<style scoped lang="scss">
.cellContainer {
  width: 100%;
  background-color: white;
  padding: 1rem 1rem 1rem 0px;
  border-bottom: solid 1px lightgray;

  .cellLeft {
    /*flex 布局*/
    display: flex;
    /*实现垂直居中*/
    align-items: center;
    /*实现水平居中*/
    justify-content: center;
    text-align: justify;
    height: 10rem;
    margin: 0 auto;
    color: #fff;
  }
  .cellCenter {
  }
  .cellRight {
    text-align: left;
    padding-left: 1rem;
    .cellName {
      height: 5rem;
      font-size: 1.4rem;
      padding-right: 1rem;
    }
    .cellDes {
      //  background: ;
      background: #f7f7f7;
      border-radius: 2px;
      padding: 0.6rem;
      display: inline-block;
      font-family: PingFangSC-Regular;
      font-size: 1.2rem;
      color: #9c9c9c;
      letter-spacing: 0;
      line-height: 1.2rem;
      margin-top: 0.8rem;
      .cell-des {
        display: inline-block;
      }
    }
    .cellPrice {
      line-height: 3rem;
      height: 3rem;
      font-size: 1.4rem;
      color: red;
    }
  }
}

.delete-button {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/shopcardcell.vue